import { ArrowLeft, Phone, Mail, MapPin, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";

const Impressum = () => {
  return (
    <div className="min-h-screen bg-[#FDFAF7]" data-testid="impressum-page">
      {/* Header */}
      <header className="bg-white border-b border-border">
        <div className="section-container py-6">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors"
            data-testid="back-to-home"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Zurück zur Startseite</span>
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="section-container py-16">
        <div className="max-w-3xl">
          <h1 className="font-heading text-4xl md:text-5xl font-medium tracking-tight text-foreground mb-12">
            Impressum
          </h1>

          {/* Angaben gemäß § 5 TMG */}
          <section className="mb-12">
            <h2 className="font-heading text-2xl font-medium text-foreground mb-6">
              Angaben gemäß § 5 TMG
            </h2>
            <div className="bg-white p-6 rounded-2xl border border-border/40">
              <p className="text-lg font-medium text-foreground mb-1">Christopher Mein</p>
              <p className="text-muted-foreground mb-4">CM Consulting</p>
              
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <MapPin className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                  <span className="text-muted-foreground">
                    Helmstedter Straße 24<br />
                    38102 Braunschweig
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <Phone className="w-5 h-5 text-primary flex-shrink-0" />
                  <a href="tel:+4917681239688" className="text-muted-foreground hover:text-primary transition-colors">
                    +49 176 81239688
                  </a>
                </div>
                <div className="flex items-center gap-3">
                  <Mail className="w-5 h-5 text-primary flex-shrink-0" />
                  <a href="mailto:kontakt@christopher-mein.de" className="text-muted-foreground hover:text-primary transition-colors">
                    kontakt@christopher-mein.de
                  </a>
                </div>
              </div>
            </div>
          </section>

          {/* Tätigkeitsart */}
          <section className="mb-12">
            <h2 className="font-heading text-2xl font-medium text-foreground mb-6">
              Tätigkeitsart
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              Freier Versicherungsmakler und Finanzanlagenvermittler
            </p>
          </section>

          {/* Erlaubnisse */}
          <section className="mb-12">
            <h2 className="font-heading text-2xl font-medium text-foreground mb-6">
              Erlaubnisse nach § 34 GewO
            </h2>
            <ul className="space-y-2 text-muted-foreground">
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                Erlaubnis nach § 34d Abs. 1 GewO (Versicherungsmakler)
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                Erlaubnis nach § 34f Abs. 1 GewO (Finanzanlagenvermittler)
              </li>
            </ul>
          </section>

          {/* Registereintrag */}
          <section className="mb-12">
            <h2 className="font-heading text-2xl font-medium text-foreground mb-6">
              Registereintrag
            </h2>
            <div className="bg-sage-50 p-6 rounded-2xl">
              <p className="text-muted-foreground mb-4">
                Eingetragen im Vermittlerregister gemäß § 11a GewO
              </p>
              <p className="text-muted-foreground mb-4">
                Deutscher Industrie- und Handelskammertag (DIHK)<br />
                Breite Straße 29<br />
                10178 Berlin
              </p>
              <p className="mb-4">
                <span className="text-muted-foreground">Registerabruf unter: </span>
                <a 
                  href="https://www.vermittlerregister.info" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-primary hover:underline inline-flex items-center gap-1"
                >
                  www.vermittlerregister.info
                  <ExternalLink className="w-4 h-4" />
                </a>
              </p>
              
              <div className="border-t border-border pt-4 mt-4">
                <p className="font-medium text-foreground mb-3">Registrierungsnummern:</p>
                <ul className="space-y-2 text-muted-foreground text-sm">
                  <li>
                    <span className="font-medium">Versicherungsvermittler (§ 34d GewO):</span><br />
                    D-EJPL-TBEG0-68
                  </li>
                  <li>
                    <span className="font-medium">Finanzanlagenvermittler (§ 34f GewO):</span><br />
                    D-F-111-S4ZJ-06
                  </li>
                </ul>
              </div>
            </div>
          </section>

          {/* Zuständige Aufsichtsbehörde */}
          <section className="mb-12">
            <h2 className="font-heading text-2xl font-medium text-foreground mb-6">
              Zuständige Aufsichtsbehörde
            </h2>
            <p className="text-muted-foreground">
              Industrie- und Handelskammer Braunschweig<br />
              Brabandtstraße 11<br />
              38100 Braunschweig<br />
              Deutschland
            </p>
          </section>

          {/* Berufsrechtliche Regelungen */}
          <section className="mb-12">
            <h2 className="font-heading text-2xl font-medium text-foreground mb-6">
              Berufsrechtliche Regelungen
            </h2>
            <ul className="space-y-2 text-muted-foreground mb-4">
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                § 34d Gewerbeordnung (GewO)
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                § 34f Gewerbeordnung (GewO)
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                Versicherungsvermittlungsverordnung (VersVermV)
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                Finanzanlagenvermittlungsverordnung (FinVermV)
              </li>
            </ul>
            <p className="text-muted-foreground">
              Einsehbar unter:{" "}
              <a 
                href="https://www.gesetze-im-internet.de" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-primary hover:underline inline-flex items-center gap-1"
              >
                www.gesetze-im-internet.de
                <ExternalLink className="w-4 h-4" />
              </a>
            </p>
          </section>

          {/* Vergütung */}
          <section className="mb-12">
            <h2 className="font-heading text-2xl font-medium text-foreground mb-6">
              Vergütung
            </h2>
            <div className="text-muted-foreground leading-relaxed space-y-4">
              <p>
                Die Vergütung für die Tätigkeit als Versicherungsmakler erfolgt in der Regel durch Provisionen, 
                die in den Versicherungsbeiträgen enthalten sind.
              </p>
              <p>
                Als Finanzanlagenvermittler erfolgt die Vergütung ebenfalls über Provisionen oder Vergütungen 
                der jeweiligen Produktanbieter.
              </p>
              <p className="font-medium text-foreground">
                Für den Kunden entstehen in der Regel keine gesonderten Kosten für die Beratung.
              </p>
            </div>
          </section>

          {/* Schlichtungsstellen */}
          <section className="mb-12">
            <h2 className="font-heading text-2xl font-medium text-foreground mb-6">
              Schlichtungsstellen für außergerichtliche Streitbeilegung
            </h2>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-white p-6 rounded-2xl border border-border/40">
                <h3 className="font-medium text-foreground mb-3">Versicherungsombudsmann e.V.</h3>
                <p className="text-muted-foreground text-sm mb-3">
                  Postfach 08 06 32<br />
                  10006 Berlin
                </p>
                <a 
                  href="https://www.versicherungsombudsmann.de" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-primary hover:underline text-sm inline-flex items-center gap-1"
                >
                  www.versicherungsombudsmann.de
                  <ExternalLink className="w-3 h-3" />
                </a>
              </div>
              <div className="bg-white p-6 rounded-2xl border border-border/40">
                <h3 className="font-medium text-foreground mb-3">Ombudsmann PKV</h3>
                <p className="text-muted-foreground text-sm mb-3">
                  Postfach 06 02 22<br />
                  10052 Berlin
                </p>
                <a 
                  href="https://www.pkv-ombudsmann.de" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-primary hover:underline text-sm inline-flex items-center gap-1"
                >
                  www.pkv-ombudsmann.de
                  <ExternalLink className="w-3 h-3" />
                </a>
              </div>
            </div>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-sage-800 text-white py-8">
        <div className="section-container text-center">
          <p className="text-sage-400 text-sm">
            © {new Date().getFullYear()} CM Consulting – Christopher Mein. Alle Rechte vorbehalten.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Impressum;
